import React from 'react';
import { Modal, Result, Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const PaymentStatusModal = ({
  open,
  onClose,
  paymentStatus
}) => {
  const isSuccess = paymentStatus === 'SUCCESS';
  const isFailed = paymentStatus === 'FAILED';

  const getResultProps = () => {
    if (isSuccess) {
      return {
        status: 'success',
        icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
        title: 'Payment Successful!',
        subTitle:
          <div className="mt-6 mb-4 flex flex-col gap-2">
            <p className="m-0">Your payment has been processed successfully.</p>
            <p className="m-0">Your registration is now complete.</p>
          </div>
      };
    } else if (isFailed) {
      return {
        status: 'error',
        icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
        title: 'Payment Failed',
        subTitle:
          <div className="mt-6 mb-4 flex flex-col gap-2">
            <p className="m-0">Unfortunately, your payment could not be processed.</p>
            <p className="m-0">Please <b>try again</b> or <b>contact your organization</b> or team manager if the problem persists.</p>
          </div>
      };
    }
    return null;
  };

  const resultProps = getResultProps();

  if (!resultProps) {
    return null;
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={true}
      maskClosable={true}
      centered
      width={500}
    >
      <Result
        {...resultProps}
        extra={[
          <Button
            size="medium"
            type="primary"
            key="close"
            onClick={onClose}
          >
            Close
          </Button>
        ]}
      />
    </Modal>
  );
};

export default PaymentStatusModal;
